<template>
  <div id="micom-page">
    <tab-header :key="$route.path" :id="id" :ex="ex" :mode="true" />
    <div class="wrapper">
      <div class="page-container">
        <div class="contents-wrapper">
          <div class="main-title">
            <h1>실험{{ id }}. {{ data[id - 1].title }}</h1>
            <hr />
            <p>{{ data[id - 1].subject }}</p>
          </div>
          <div class="tabs">
            <ul>
              <!-- <li @click="setContent(0)">실험소개</li>
                    <li @click="setContent(1)">사용방법</li>
                    <li @click="setContent(2)">이론</li> -->
              <li @click="setContent(0)">사용방법</li>
              <li @click="setContent(1)">이론</li>
              <li @click="setContent(2)">회로도 예시</li>
              <li @click="setContent(3)">실험시작</li>
            </ul>
          </div>
          <div class="contents">
            <div v-if="selected == 0" class="tutorial">
              <video
                autoplay
                muted
                controls
                width="700px"
                :src="
                  require(`../../../assets/images/micom/tutorial/ex${id}.mp4`)
                "
              ></video>
            </div>
            <div v-else-if="selected == 1" class="lesson">
              <slick
                id="carousel2"
                ref="slick2"
                @init="handleInit"
                @afterChange="handleAfterChange"
                @reInit="handlereInit"
                :options="slickOptions"
              >
                <template v-for="i in slides[id - 1].pages">
                  <div :key="id + '_' + i">
                    <img
                      :src="
                        require(`../../../assets/images/micom/lesson/ex${id}/ex${i +
                          1}.jpg`)
                      "
                    />
                  </div>
                </template>
              </slick>
              <span class="slick-paging"></span>
            </div>
            <div v-else-if="selected == 2" class="introduction">
              <div class="introduction_slide">
                <v-sheet class="mx-auto" max-width="800">
                  <v-slide-group v-model="model" class="pa-4" show-arrows>
                    <v-slide-item
                      v-for="name in filenames"
                      :key="name"
                      v-slot="{ active, toggle }"
                    >
                      <v-card
                        :color="active ? 'green lighten-2' : 'grey lighten-1'"
                        class="ma-4"
                        height="200px"
                        width="200px"
                        @click="toggle"
                      >
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center"
                        >
                          <v-scale-transition>
                            <img
                              style="width:200px; height:200px;"
                              :src="
                                require(`../../../assets/images/micom/circuit/${filetype}/${name}.png`)
                              "
                            />
                            <v-icon
                              v-if="active"
                              color="white"
                              size="48"
                              v-text="'mdi-close-circle-outline'"
                            ></v-icon>
                          </v-scale-transition>
                        </v-row>
                      </v-card>
                    </v-slide-item>
                  </v-slide-group>

                  <v-expand-transition>
                    <v-sheet
                      v-if="model != null"
                      height="500"
                      width="800"
                      elevation="3"
                      class="v_expand"
                    >
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center"
                      >
                        <img
                          width="750px"
                          height="450px"
                          style="object-fit: contain;"
                          :src="
                            require(`../../../assets/images/micom/circuit/${filetype}/${filenames[model]}.png`)
                          "
                        />
                      </v-row>
                    </v-sheet>
                  </v-expand-transition>
                </v-sheet>
              </div>
            </div>
            <div v-else class="simulation"></div>
          </div>
        </div>
        <app-footer class="footer" />
      </div>
    </div>
  </div>
</template>

<script>
import TabHeader from "../../../components/utils/common/TabHeader.vue";
import AppFooter from "../../../components/utils/AppFooter.vue";
import Slick from "vue-slick";
import { experimentData } from "../../../data/experiments/experiement.js";
import $ from "jquery";

export default {
  components: { TabHeader, AppFooter, Slick },
  props: ["id", "ex"],
  data() {
    return {
      data: experimentData.data().micom,
      selected: 0,
      intro_selected: 0,
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<i class="fas fa-chevron-left slick-arrow slick-prev"></i>',
        nextArrow: '<i class="fas fa-chevron-right slick-arrow slick-next"></i>'
      },
      model: 0,
      slides: [
        { id: 1, pages: 15 },
        { id: 2, pages: 2 },
        { id: 3, pages: 10 },
        { id: 4, pages: 15 },
        { id: 5, pages: 0 }
      ],
      path: ""
    };
  },
  watch: {
    $route(to, from) {
      if (!this.$refs.slick2) return;
      this.$refs.slick2.destroy();
      this.$nextTick(() => {
        this.$refs.slick2.create();
      });
    }
  },
  mounted() {
    this.setContent(0);
  },
  computed: {
    filenames() {
      if (this.id === "1") return ["ex1", "ex2", "ex7"];
      else if (this.id === "2") return ["ex3", "ex4", "ex5", "ex6"];
      else if (this.id === "3") return ["ex1", "ex3", "ex5"];
      else if (this.id === "4") return ["ex2", "ex4"];
      else return ["ex3", "ex4", "ex5", "ex1", "ex2"];
    },
    filetype() {
      if (this.id === "1" || this.id === "2") return "digital";
      else if (this.id === "3" || this.id === "4") return "analog";
      else return "mixed";
    }
  },
  methods: {
    setPaging(slick, currentSlide) {
      const status = document.querySelector("span.slick-paging");
      const i = (currentSlide || 0) + 1;
      status.innerText = i + "/" + slick.slideCount;
    },
    handleAfterChange(event, slick, currentSlide) {
      this.setPaging(slick, currentSlide);
    },
    handleInit(event, slick) {
      this.setPaging(slick, 0);
    },
    handlereInit(event, slick) {
      this.$refs.slick2.destroy();
      this.$nextTick(() => {
        this.$refs.slick2.create();
      });
      this.setPaging(slick, 0);
    },
    setContent(i) {
      this.selected = i;
      $(".tabs li").removeClass("selected");
      $(".tabs li:eq(" + i + ")").addClass("selected");
      if (i === 3) {
        // this.$router.push({ path: '/com/ex/' + this.id })
        window.location.replace("/v1/com/ex/" + this.id);
      }
    },
    setIntroTab(idx) {
      this.intro_selected = idx;
    }
  }
};
</script>

<style lang="scss">
#micom-page {
  position: relative;
  word-break: keep-all;
  .wrapper {
    position: absolute;
    top: 250px;
    width: 100%;
    height: auto;
  }
  .page-container {
    position: relative;
    width: 100%;
    min-height: 1380px;
  }
  .footer {
    position: absolute;
    bottom: 0px;
    width: 100%;
  }
  div.mid-title {
    display: inline-block;
    border: 3px solid #4caf50;
    border-left: none;
    border-right: none;
    color: black;
    font-size: 1.3rem;
    font-weight: bold;
  }
}
#micom-page .contents-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  padding-top: 70px;
  .main-title {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    hr {
      width: 35%;
      margin: 10px auto;
      border: 1px solid #2156d0;
      background-color: #2156d0;
    }
    p {
      padding: 30px 10px;
      font-size: 1.1rem;
      margin-bottom: 0px;
    }
    h1 {
      font-size: 1.6rem;
      font-weight: bold;
    }
  }
  .tabs {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    margin: 10px 0px;
    ul {
      list-style: none;
      padding: 0px;
    }
    li {
      display: inline-block;
      width: 220px;
      font-size: 1.3rem;
      padding: 10px;
      border: 1px solid #bbb;
      border-right: none;
      font-weight: bold;
    }
    li:last-child {
      border-right: 1px solid #bbb;
    }
    li:hover {
      border: 2px solid #2156d0;
      color: #2156d0;
      cursor: pointer;
    }
    li.selected {
      background-color: #2156d0;
      border: 2px solid #2156d0;
      color: white;
    }
  }
  .contents {
    width: 100%;
    margin-top: 10px;
    .introduction {
      position: relative;
      padding-top: 40px;
      .introduction_img {
        position: absolute;
        width: 70%;
        max-height: 700px;
        left: 50%;
        transform: translate(-50%, 10%);
        border: 1.3px solid #999;
      }
    }
    .lesson {
      position: relative;
      padding-top: 40px;
      .slick-arrow {
        opacity: 0.5;
        transform: translateY(-50%);
        font-size: 24px;
        z-index: 10;
        transform: 0.3s opacity;
      }
      .slick-arrow:hover {
        cursor: pointer;
        opacity: 1;
        transform: 0.3s opacity;
      }
      .slick-prev {
        position: absolute;
        top: 50%;
        left: 10%;
      }
      .slick-next {
        position: absolute;
        top: 50%;
        right: 10%;
      }
      img {
        width: 75%;
        max-height: 700px;
        margin: 0 auto;
        border: 1.3px solid #777;
        padding: 20px;
      }
      span {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        font-size: 1.2rem;
        color: #555;
      }
    }
  }
}
#micom-page .contents .tutorial {
  position: relative;
  video {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 10%);
    width: 80%;
    max-height: 700px;
  }
}
#micom-page .contents .introduction {
  .introduction_tabs {
    ul {
      display: flex;
      justify-content: center;
      li {
        list-style: none;
        text-align: center;
        font-size: 1.2rem;
        padding: 5px 25px;
        margin: 20px 10px;
        color: #777;
      }
      li:hover {
        color: black;
        font-weight: bold;
        transition: 0.3s all;
        cursor: pointer;
      }
      li.selected {
        border: 3px solid #4caf50;
        border-left: none;
        border-right: none;
        color: black;
        font-size: 1.3rem;
        font-weight: bold;
      }
      hr {
        width: 120px;
        display: none;
      }
    }
  }
  .introduction_slider {
    margin: 0 auto;
    width: 90%;
    padding: 20px;
  }
}

@media (max-width: 785px) {
  #miocom-page .wrapper {
    top: 220px;
  }

  #micom-page .page-container {
    min-height: 1100px;
  }
  #micom-page .contents-wrapper .tabs {
    height: 180px;
  }
  #micom-page .contents-wrapper .tabs ul {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  #micom-page .contents-wrapper .tabs li {
    display: block;
    border-right: 1px solid #bbb;
  }

  #micom-page .contents .tutorial video {
    padding-top: 80px;
  }

  #micom-page .v_expand {
    display: none;
  }
}

@media (max-width: 650px) {
  #micom-page .contents-wrapper {
    padding-top: 0px;
  }
}
</style>
